import React, { useState } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';
export const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    partyLocation: '',
    eventDate: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<{
    success?: boolean;
    message?: string;
  }>({});
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({});
    try {
      const serviceId = 'service_wywqkye';
      const templateId = 'template_6d30pxw';
      const publicKey = 'nKRg8BnYcuXf4azVI';
      const formattedData = {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        message: formData.message,
        packages: 'General inquiry - no packages selected',
        total: '$0',
        item_count: 0,
        event_date: formData.eventDate || 'N/A',
        start_time: 'N/A',
        end_time: 'N/A',
        location_type: 'N/A',
        location_address: formData.partyLocation || 'N/A',
        location_details: 'N/A'
      };
      console.log('Sending to EmailJS:', formattedData);
      const result = await emailjs.send(serviceId, templateId, formattedData, publicKey);
      if (result.status === 200) {
        setSubmitStatus({
          success: true,
          message: 'Thank you for your message! We will get back to you shortly.'
        });
        setFormData({
          name: '',
          email: '',
          phone: '',
          partyLocation: '',
          eventDate: '',
          message: ''
        });
      } else {
        throw new Error('Failed to send email');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus({
        success: false,
        message: 'There was a problem sending your message. Please try again or contact us directly at info@toddlertimeatl.com.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="bg-white w-full" data-id="element-751">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-752">
        <div className="text-center mb-12" data-id="element-753">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-754">
            Contact Us
          </h1>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-755">
            Have questions? We're here to help!
          </p>
        </div>

        {/* Booking CTA Banner */}
        <div className="mb-12 bg-gradient-to-r from-primary-50 to-secondary-50 rounded-xl p-8 border-2 border-primary-200" data-id="element-756">
          <div className="text-center max-w-3xl mx-auto" data-id="element-757">
            <h2 className="text-2xl font-heading font-bold text-gray-900 mb-4" data-id="element-758">
              Know which package you want but still have a few questions?
            </h2>
            <p className="text-lg text-gray-700 mb-4 leading-relaxed" data-id="element-759">
              No worries. Just click Book Now to fill out the booking inquiry
              form, and someone from our team will reach out to confirm the
              details. Nothing's locked in yet.
            </p>
            <Link to="/cart" className="inline-flex items-center px-8 py-3 bg-secondary-500 text-white rounded-full font-bold text-lg shadow-lg hover:bg-secondary-600 transition-all mb-4" onClick={() => window.scrollTo(0, 0)} data-id="element-760">
              Book Now
            </Link>
            <p className="text-base text-gray-600" data-id="element-761">
              If you have more general questions first, use the form below.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-762">
          {/* Contact Info Sidebar */}
          <div className="bg-white rounded-lg shadow-lg p-6 lg:col-span-1 border border-gray-100" data-id="element-763">
            <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-764">
              Get in Touch
            </h3>
            <div className="space-y-4" data-id="element-765">
              <div className="flex items-start" data-id="element-766">
                <div className="flex-shrink-0" data-id="element-767">
                  <PhoneIcon className="h-6 w-6 text-primary-500" data-id="element-768" />
                </div>
                <div className="ml-3 text-base text-gray-500" data-id="element-769">
                  <a href="tel:4702430414" className="hover:text-primary-600" data-id="element-770">
                    (470) 243-0414
                  </a>
                </div>
              </div>
              <div className="flex items-start" data-id="element-771">
                <div className="flex-shrink-0" data-id="element-772">
                  <MailIcon className="h-6 w-6 text-primary-500" data-id="element-773" />
                </div>
                <div className="ml-3 text-base text-gray-500" data-id="element-774">
                  <a href="mailto:info@toddlertimeatl.com" className="hover:text-primary-600" data-id="element-775">
                    info@toddlertimeatl.com
                  </a>
                </div>
              </div>
              <div className="flex items-start" data-id="element-776">
                <div className="flex-shrink-0" data-id="element-777">
                  <MapPinIcon className="h-6 w-6 text-primary-500" data-id="element-778" />
                </div>
                <div className="ml-3 text-base text-gray-500" data-id="element-779">
                  <p data-id="element-780">Serving the Greater Atlanta Area</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-781">
                <div className="flex-shrink-0" data-id="element-782">
                  <CalendarIcon className="h-6 w-6 text-primary-500" data-id="element-783" />
                </div>
                <div className="ml-3 text-base text-gray-500" data-id="element-784">
                  <p data-id="element-785">Available 7 days a week</p>
                  <p data-id="element-786">Weekend hours: 9am - 7:30pm</p>
                  <p data-id="element-787">Contact us for weekday inquiries</p>
                </div>
              </div>
            </div>
            <div className="mt-8" data-id="element-788">
              <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider" data-id="element-789">
                Follow Us
              </h4>
              <div className="mt-4 flex space-x-6" data-id="element-790">
                <a href="https://www.facebook.com/toddlertimeatl" className="text-gray-400 hover:text-primary-500" target="_blank" rel="noopener noreferrer" data-id="element-791">
                  <span className="sr-only" data-id="element-792">Facebook</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-793">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-794" />
                  </svg>
                </a>
                <a href="https://www.instagram.com/toddlertime.softplay?utm_source=ig_web_button_share_sheet&igsh=MWZoOXp3NzVocGg1cg==" className="text-gray-400 hover:text-primary-500" target="_blank" rel="noopener noreferrer" data-id="element-795">
                  <span className="sr-only" data-id="element-796">Instagram</span>
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-797">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-798" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Simple Contact Form */}
          <div className="bg-white rounded-lg shadow-lg p-6 lg:col-span-2 border border-gray-100" data-id="element-799">
            <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-800">
              Send Us a Message
            </h3>

            {submitStatus.message && <div className={`mb-6 p-4 rounded-md ${submitStatus.success ? 'bg-green-50 text-green-800 border border-green-200' : 'bg-red-50 text-red-800 border border-red-200'}`} data-id="element-801">
                {submitStatus.message}
              </div>}

            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-802">
              <div data-id="element-803">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-804">
                  Full Name
                </label>
                <input type="text" name="name" id="name" value={formData.name} onChange={handleChange} required className="mt-1 py-3 px-4 block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 border-gray-300 rounded-md" data-id="element-805" />
              </div>

              <div data-id="element-806">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-807">
                  Email
                </label>
                <input type="email" name="email" id="email" value={formData.email} onChange={handleChange} required className="mt-1 py-3 px-4 block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 border-gray-300 rounded-md" data-id="element-808" />
              </div>

              <div data-id="element-809">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-810">
                  Phone Number
                </label>
                <input type="tel" name="phone" id="phone" value={formData.phone} onChange={handleChange} required className="mt-1 py-3 px-4 block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 border-gray-300 rounded-md" data-id="element-811" />
              </div>

              <div data-id="element-812">
                <label htmlFor="partyLocation" className="block text-sm font-medium text-gray-700" data-id="element-813">
                  Party Location
                </label>
                <input type="text" name="partyLocation" id="partyLocation" value={formData.partyLocation} onChange={handleChange} placeholder="Enter your address or ZIP code" className="mt-1 py-3 px-4 block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 border-gray-300 rounded-md" data-id="element-814" />
              </div>

              <div data-id="element-815">
                <label htmlFor="eventDate" className="block text-sm font-medium text-gray-700" data-id="element-816">
                  Event Date
                </label>
                <input type="date" name="eventDate" id="eventDate" value={formData.eventDate} onChange={handleChange} className="mt-1 py-3 px-4 block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 border-gray-300 rounded-md" data-id="element-817" />
              </div>

              <div data-id="element-818">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700" data-id="element-819">
                  Message
                </label>
                <textarea name="message" id="message" rows={6} value={formData.message} onChange={handleChange} required placeholder="Tell us about your event, ask questions, or share any special requests..." className="mt-1 py-3 px-4 block w-full shadow-sm focus:ring-primary-500 focus:border-primary-500 border border-gray-300 rounded-md" data-id="element-820"></textarea>
              </div>

              <button type="submit" disabled={isSubmitting} className="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-75" data-id="element-821">
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>;
};